import React, { useEffect, useState } from 'react'
import scanLoadingGif from '../../assests/scan_loading.gif'
import circular_loading_gif from '../../assests/circular_loading_gif.gif'
import { Box, Button, CircularProgress, Modal, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const ACCENT_BLUE = '#22638f';
const ACCENT_BLUE_DARK = '#1b4f73';
const TEXT_BODY = '#3b4a63';

function ProcessingForm({
    isProcessing,
    isCvInferenceResponce,
    getUserMetaData,
    setUpdatedUserMetaData,
    isMetaDataServerResponce,
    setIsProcessing,
    onCallInferenceServer,
    onCancleClick,
    cropname
}) {
    const TYPE_ARRAY = 1
    const TYPE_STRING = "STRING"
    const [formValues, setFormValues] = useState({});
    const [loading, setLoading] = useState(false)
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (isProcessing && getUserMetaData?.length === 0) {
            setLoading(true);
            onCallInferenceServer();
        }
    }, [isProcessing, getUserMetaData]);

    useEffect(() => {
        if (isProcessing === false) {
            setLoading(isProcessing)
            setFormValues({})
        }
    }, [isProcessing])

    useEffect(() => {
        const updatedMetadata = getUserMetaData?.reduce((acc, item) => {
            const value = formValues[item.metadata_key] || '';
            acc[item.metadata_key] = value;
            return acc;
        }, {});

        setUpdatedUserMetaData(updatedMetadata);
    }, [formValues, getUserMetaData]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const renderFormFields = () => {
        return getUserMetaData?.map((item, index) => {
            if (item.metadata_type === TYPE_STRING) {
                return (
                    <TextField
                        key={index}
                        id={item.metadata_key}
                        label={item.metadata_value}
                        variant="standard"
                        size="small"
                        fullWidth
                        sx={{
                            mt: 0.5,
                            mb: 2,
                            '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.85)' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                            '& .MuiInput-root': { color: '#fff' },
                            '& .MuiInput-underline:before': { borderBottomColor: 'rgba(255,255,255,0.4)' },
                            '& .MuiInput-underline:hover:before': { borderBottomColor: 'rgba(255,255,255,0.7) !important' },
                            '& .MuiInput-underline:after': { borderBottomColor: '#fff' },
                        }}
                        name={item.metadata_key}
                        value={formValues[item.metadata_key] || ''}
                        onChange={handleInputChange}
                    />
                );
            } else if (item.metadata_type === TYPE_ARRAY && item.metadata_values) {
                return (
                    <Box key={index} sx={{ mb: 2 }}>
                        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginBottom: 6 }}>
                            {item.metadata_value}
                        </div>
                        <select
                            name={item.metadata_key}
                            value={formValues[item.metadata_key] || ''}
                            onChange={handleInputChange}
                            style={{
                                width: '100%',
                                padding: '8px 10px',
                                borderRadius: 6,
                                border: '1px solid rgba(255,255,255,0.4)',
                                fontSize: 13.5,
                                color: TEXT_BODY,
                                backgroundColor: '#fff',
                            }}
                        >
                            {item.metadata_values?.map((value, valueIndex) => (
                                <option key={valueIndex} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </Box>
                );
            }
            return null;
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setUpdatedUserMetaData(formValues);
        onCallInferenceServer();
    };

    const handleOldInference = () => {
        setShowPopup(false);
        onCallInferenceServer(true);
    };

    const handleNewKserve = () => {
        setShowPopup(false);
        onCallInferenceServer(false);
    };

    const onCancel = () => {
        setLoading(false)
        setIsProcessing(false)
        setFormValues({})
        onCancleClick()
    }

    const lightBtnSx = {
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        px: 2.5,
        backgroundColor: 'rgba(255,255,255,0.15)',
        color: '#fff',
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.25)' },
    };

    const solidBtnSx = {
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        px: 2.5,
        boxShadow: 'none',
        backgroundColor: '#fff',
        color: ACCENT_BLUE,
        '&:hover': { backgroundColor: '#eef4fb', boxShadow: 'none' },
    };

    return (
        <Modal open={isProcessing}>
            <Box sx={{ ...style, overflow: 'auto', maxHeight: '70vh' }}>
                {/* Processing zone — white, matches modal shell */}
                <Box sx={{ p: 3, textAlign: 'center' }}>
                    {isCvInferenceResponce ? (
                        <img src={circular_loading_gif} alt="Loading" height={90} />
                    ) : (
                        <>
                            <div style={{ fontSize: 15, fontWeight: 700, color: ACCENT_BLUE, marginBottom: 10 }}>
                                Processing...
                            </div>
                            <img src={scanLoadingGif} alt="Scan Loading" height={100} width={230} style={{ borderRadius: 8, objectFit: 'contain' }} />
                            <div style={{ fontSize: 13, color: '#8a95a8', marginTop: 12 }}>
                                Please wait as this may take<br />a few more seconds...
                            </div>
                        </>
                    )}
                </Box>

                {/* Metadata / actions zone — solid accent-blue panel, white text (matches original) */}
                {getUserMetaData?.length !== 0 ? (
                    <Box sx={{ backgroundColor: ACCENT_BLUE, p: 2.5, borderRadius: '0 0 16px 16px' }}>
                        {loading ? (
                            <>
                                {(isMetaDataServerResponce === 200 && loading) && (
                                    <Box sx={{ textAlign: 'center' }}>
                                        <img src={circular_loading_gif} alt="Loading" height={80} />
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                                            <Button onClick={onCancel} sx={lightBtnSx}>Cancel</Button>
                                        </Box>
                                    </Box>
                                )}
                                {!(isMetaDataServerResponce === 200) && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                        <CircularProgress size={26} sx={{ color: '#fff' }} />
                                    </Box>
                                )}
                            </>
                        ) : (
                            <Box>
                                {renderFormFields()}
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 1 }}>
                                    <Button onClick={onCancel} sx={lightBtnSx}>Cancel</Button>
                                    <Button onClick={handleSubmit} sx={solidBtnSx}>Proceed</Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                ) : (
                    <Box sx={{ backgroundColor: ACCENT_BLUE, p: 2.5, display: 'flex', justifyContent: 'flex-end', borderRadius: '0 0 16px 16px' }}>
                        <Button onClick={onCancel} sx={lightBtnSx}>Cancel</Button>
                    </Box>
                )}

                <Dialog
                    open={showPopup}
                    onClose={() => setShowPopup(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{ sx: { borderRadius: '16px' } }}
                >
                    <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 700, color: TEXT_BODY }}>
                        Select Inference Type
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" sx={{ color: '#8a95a8', fontSize: 13.5 }}>
                            Please choose the inference type you want to use.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleOldInference} sx={{ borderRadius: '8px', textTransform: 'none', color: TEXT_BODY }}>Old Inference</Button>
                        <Button onClick={handleNewKserve} sx={{ borderRadius: '8px', textTransform: 'none', backgroundColor: ACCENT_BLUE, color: '#fff', '&:hover': { backgroundColor: ACCENT_BLUE_DARK } }} autoFocus>New Kserve</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Modal>
    )
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 340,
    bgcolor: '#fff',
    boxShadow: '0 12px 40px rgba(12, 61, 110, 0.22)',
    borderRadius: '16px',
    overflow: 'hidden',
};

export default ProcessingForm